// React
import React, { Component } from "react";
import PropTypes from "prop-types";
// Redux
import { connect } from "react-redux";
import { compose } from "redux";
// i18n
import { withNamespaces } from "react-i18next";
import Notice from "../../../components/Notice";
// Styles
import styles from "./PaymentHistory.css";
import Tooltip from "../../../components/Tooltip";
import NoInformation from "../../../components/NoInformation";
import TransactionStateLabel from "./components/TransactionStateLabel";
import TransactionAmountLabel from "./components/TransactionAmountLabel";
// Ducks
import { getPaymentHistory } from "./PaymentHistory.ducks";

class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentHistory: [],
      paymentHistoryDetail: {},
      showPaymentHistoryDetail: false
    };
  }

  componentDidMount() {
    this.getPaymentHistoryAsync();
  }

  componentWillUnmount() {
    if (this._paymentHistoryAsyncRequest) {
      this._paymentHistoryAsyncRequest.cancel();
    }
  }

  getPaymentHistoryAsync() {
    const { getPaymentHistory } = this.props;

    this._paymentHistoryAsyncRequest = getPaymentHistory().then((paymentHistory) => {
      this._paymentHistoryAsyncRequest = null;
      this.setState({
        showPaymentHistoryDetail: false,
        paymentHistory: paymentHistory
      });
    });
  }

  handlePaymentHistoryDetailClick(transactionId) {
    const { paymentHistory } = this.state;
    const paymentHistoryDetailFound = paymentHistory.find(
      (element) => element.transactionId === transactionId
    );

    this.setState({
      showPaymentHistoryDetail: true,
      paymentHistoryDetail: paymentHistoryDetailFound
    });
  }

  handleRefreshClick() {
    this.getPaymentHistoryAsync();
  }

  handleBackToOverviewClick() {
    this.setState({
      showPaymentHistoryDetail: false,
      paymentHistoryDetail: {}
    });
  }

  render() {
    const { t, isUserActive } = this.props;
    const { paymentHistory, paymentHistoryDetail, showPaymentHistoryDetail } = this.state;

    // PaymentHistory - Overview
    if (showPaymentHistoryDetail === false) {
      return (
        <div className="container" style={{ paddingBottom: 40 }}>
          <div style={styles.headerContainer}>
            <h1 style={styles.pageTitle} className="txt-color-blue">
              {t("modules.localization.register.authenticated.paymentHistory.title")}
            </h1>
            <button
              className="btn btn-primary"
              onClick={() => {
                this.handleRefreshClick();
              }}
            >
              {t("modules.localization.register.generals.button.refresh")}
            </button>
          </div>
          {isUserActive === false && (
            <div style={{ marginTop: 40 }}>
              <Notice
                type="danger"
                message={t(
                  `modules.localization.register.authenticated.smartNotifications.label.deletedCandidate`
                )}
              />
            </div>
          )}
          {paymentHistory && !paymentHistory.length && (
            <NoInformation
              label={t(
                `modules.localization.register.authenticated.paymentHistory.emptyPaymentHistory`
              )}
            />
          )}
          {paymentHistory && paymentHistory.length > 0 && (
            <table class="table table-hover table-striped" style={styles.paymentHistoryTable}>
              <thead>
                <tr>
                  <th scope="col">
                    {t(
                      `modules.localization.register.authenticated.paymentHistory.table.header.orderDate`
                    )}
                  </th>
                  <th scope="col">
                    {t(
                      `modules.localization.register.authenticated.paymentHistory.table.header.orderNumber`
                    )}
                  </th>
                  <th scope="col">
                    {t(
                      `modules.localization.register.authenticated.paymentHistory.table.header.order`
                    )}
                  </th>
                  <th scope="col" style={styles.paymentHistoryTableHeaderRightBound}>
                    {t(
                      `modules.localization.register.authenticated.paymentHistory.table.header.totalAmount`
                    )}
                  </th>
                  <th scope="col" style={styles.paymentHistoryTableHeaderCentered}>
                    {t(
                      `modules.localization.register.authenticated.paymentHistory.table.header.status`
                    )}
                  </th>
                  <th scope="col" />
                </tr>
              </thead>
              <tbody>
                {paymentHistory.map((paymentHistoryItem) => (
                  <tr>
                    <td style={styles.paymentHistoryTableDataCell}>
                      {paymentHistoryItem.transactionDateFormatted}
                    </td>
                    <td style={styles.paymentHistoryTableDataCell}>
                      {paymentHistoryItem.orderNumber}
                    </td>
                    <td width="40%" style={styles.paymentHistoryTableDataCell}>
                      {paymentHistoryItem.transactionItemsFullNames.length > 0 && (
                        <Tooltip
                          message={paymentHistoryItem.transactionItemsFullNames}
                          position="right"
                        >
                          {paymentHistoryItem.transactionItemsShortName}&nbsp;
                        </Tooltip>
                      )}
                      {!paymentHistoryItem.transactionItemsFullNames.length && (
                        <span>{paymentHistoryItem.transactionItemsShortName}</span>
                      )}
                    </td>
                    <td style={styles.paymentHistoryTableDataCellRightBound}>
                      <TransactionAmountLabel
                        transactionState={paymentHistoryItem.registerTransactionState}
                        totalAmountFormatted={paymentHistoryItem.totalAmountFormatted}
                      />
                    </td>
                    <td align="center" style={styles.paymentHistoryTableDataCell}>
                      <TransactionStateLabel
                        transactionState={paymentHistoryItem.registerTransactionState}
                        transactionStateL10n={paymentHistoryItem.registerTransactionStateL10n}
                      />
                    </td>
                    <td align="right" style={styles.paymentHistoryTableDataCell}>
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          this.handlePaymentHistoryDetailClick(paymentHistoryItem.transactionId);
                        }}
                      >
                        {t("modules.localization.register.generals.button.details")}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      );
    }
    // PaymentHistory - Details
    else {
      return (
        <div className="container" style={{ paddingBottom: 40 }}>
          <div style={styles.headerContainer}>
            <h1 style={styles.pageTitle} className="txt-color-blue">
              {t("modules.localization.register.authenticated.paymentHistory.details.title")}
            </h1>
            <button
              className="btn btn-primary"
              onClick={() => { this.handleBackToOverviewClick(); }}
            >
              {t("modules.localization.register.generals.button.backTo.overview")}
            </button>
          </div>
          {isUserActive === false && (
            <div style={{ marginTop: 40 }}>
              <Notice
                type="danger"
                message={t(
                  `modules.localization.register.authenticated.smartNotifications.label.deletedCandidate`
                )}
              />
            </div>
          )}
          {paymentHistoryDetail && (
            <div>
              <hr />
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <dl class="row">
                  <dt style={styles.paymentHistoryDetaildescriptionList} class="col-xs-4">
                    {t(
                      `modules.localization.register.authenticated.paymentHistory.table.header.orderNumber`
                    )}
                  </dt>
                  <dd style={styles.paymentHistoryDetaildescriptionList} class="col-xs-8">
                    {paymentHistoryDetail.orderNumber}
                  </dd>

                  <dt style={styles.paymentHistoryDetaildescriptionList} class="col-xs-4">
                    {t(
                      `modules.localization.register.authenticated.paymentHistory.table.header.orderDate`
                    )}
                  </dt>
                  <dd style={styles.paymentHistoryDetaildescriptionList} class="col-xs-8">
                    {paymentHistoryDetail.transactionDateFormatted}
                  </dd>
                </dl>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <dl class="row">
                  <dt style={styles.paymentHistoryDetaildescriptionList} class="col-xs-4">
                    {t(
                      `modules.localization.register.authenticated.paymentHistory.table.header.status`
                    )}
                  </dt>
                  <dd style={styles.paymentHistoryDetaildescriptionList} class="col-xs-8">
                    {t(paymentHistoryDetail.registerTransactionStateL10n)}
                  </dd>

                  <dt style={styles.paymentHistoryDetaildescriptionList} class="col-xs-4">
                    {t(
                      `modules.localization.register.authenticated.paymentHistory.table.header.totalAmount`
                    )}
                  </dt>
                  <dd style={styles.paymentHistoryDetaildescriptionList} class="col-xs-8">
                    {paymentHistoryDetail.totalAmountFormatted}
                  </dd>
                </dl>
              </div>
              <hr />
              <br />
              <br />
              <table class="table table-hover table-striped" style={styles.paymentHistoryTable}>
                <thead>
                  <tr>
                    <th scope="col">
                      {t(
                        `modules.localization.register.authenticated.paymentHistory.details.table.header.order`
                      )}
                    </th>
                    <th scope="col">
                      {t(
                        `modules.localization.register.authenticated.paymentHistory.details.table.header.description`
                      )}
                    </th>
                    <th scope="col" style={styles.paymentHistoryTableHeaderCentered}>
                      {t(
                        `modules.localization.register.authenticated.paymentHistory.details.table.header.quantity`
                      )}
                    </th>
                    <th scope="col">
                      {t(
                        `modules.localization.register.authenticated.paymentHistory.details.table.header.priceEach`
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {paymentHistoryDetail.paymentHistoryDetailItems.map(
                    (paymentHistoryDetailItem) => (
                      <tr>
                        <td width="40%" style={styles.paymentHistoryTableDataCell}>
                          {paymentHistoryDetailItem.itemName}
                        </td>
                        <td width="40%" style={styles.paymentHistoryTableDataCell}>
                          {paymentHistoryDetailItem.itemDescription}
                        </td>
                        <td width="10%" align="center" style={styles.paymentHistoryTableDataCell}>
                          {paymentHistoryDetailItem.quantity}
                        </td>
                        <td width="10%" style={styles.paymentHistoryTableDataCell}>
                          {paymentHistoryDetailItem.unitPriceFormatted}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      );
    }
  }
}

PaymentHistory.propTypes = {
  getPaymentHistory: PropTypes.func.isRequired,
  isUserActive: PropTypes.bool,
  t: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  isUserActive: state.auth.profile.isUserActive
});

const mapDispatchToProps = {
  getPaymentHistory
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNamespaces()
)(PaymentHistory);
